import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

// --------------------->>>>>>>>>>>>>>>   login api call   <<<<<<<<<<<<<<-----------------------------
const LOGIN_SERVICE = ({commit}, config) => {
  return ApiServices.userLogin(config)
    .then(response => {
      commit('userLogin', response)
      localStorage.setItem('email', response.data.email)
      localStorage.setItem('userName', response.data.name)
      localStorage.setItem('roleId', response.data.role_id)
      localStorage.setItem('token', 'Bearer ' + response.token)
      that.SUCCESS_TOAST_MSG(response.message)
    }).catch((err) => {
      that.ERROR_TOAST_MSG(err.message)
    })
}

// --------------------->>>>>>>>>>>>>>>   login api call   <<<<<<<<<<<<<<-----------------------------
const REGISTER_USER = ({commit}, config) => {
  return ApiServices.userRegister(config)
}
// --------------------->>>>>>>>>>>>>>>   End of login api call   <<<<<<<<<<<<<<-----------------------------

// --------------------->>>>>>>>>>>>>>>   login api call   <<<<<<<<<<<<<<-----------------------------
const FORGOT_PASSWORD = ({commit}, config) => {
  return ApiServices.forgotPassword(config)
}
// --------------------->>>>>>>>>>>>>>>   End of login api call   <<<<<<<<<<<<<<-----------------------------



// --------------------->>>>>>>>>>>>>>>   Get User Details api call   <<<<<<<<<<<<<<-----------------------------
const GET_USER_DETAILS = ({commit}, data) => {
  return ApiServices.getUserDetails(data)
  .then((response) => {
    commit('userDetails', response)
  })
}
// --------------------->>>>>>>>>>>>>>>   End of getting user details api call   <<<<<<<<<<<<<<-----------------------------

// --------------------->>>>>>>>>>>>>>>   Get User Details api call   <<<<<<<<<<<<<<-----------------------------
const RESET_PASSWORD = ({}, data) => {
  return ApiServices.resetPassword(data)
}
// --------------------->>>>>>>>>>>>>>>   End of getting user details api call   <<<<<<<<<<<<<<-----------------------------

// --------------------->>>>>>>>>>>>>>>   Edit Profile api call   <<<<<<<<<<<<<<-----------------------------
const EDIT_PROFILE = ({}, data) => {
  return ApiServices.editProfile(data)
}
// --------------------->>>>>>>>>>>>>>>   End of edit profile api call   <<<<<<<<<<<<<<-----------------------------

// Create User
const CREATE_USER = ({}, data) => {
  return ApiServices.createUser(data)
}
const CHANGE_ADMIN_PASSWORD = ({commit}, data) => {
  return ApiServices.changeAdminPassword(data).then((response) => {
    that.SUCCESS_TOAST_MSG(response.message)
  }).catch((error) => {
    that.ERROR_TOAST_MSG(error.message)
  })
}
export default {
  LOGIN_SERVICE,
  GET_USER_DETAILS,
  REGISTER_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  EDIT_PROFILE,
  CREATE_USER,
  CHANGE_ADMIN_PASSWORD
}



// WEBPACK FOOTER //
// ./src/store/modules/authentication/actions.js